<div class="currentHoldTimeContent d-flex flex-column">
    <div class="search-box live-search w-75 mx-auto my-2" [hidden]="!searchOpen">
        <input type="search" class="form-control" autocomplete="off" [(ngModel)]="filterValue"
        (ngModelChangeDebounced)="filterValue" [ngModelChangeDebounceTime]="400" (ngModelChange)="applyFilter()" placeholder="Search" cvLocalizedPlaceholder
            langSection="Common" langKey="Search" />
        <span class="clear-input" role="button" tabindex="0" [hidden]="filterValue.length === 0"
            (click)="clearFilter()"></span>
    </div>
    <div class="h-100 flex-fill" *ngIf="!noData" style="overflow-y: auto;">
        <ag-grid-angular *ngIf="gridOptions && !noData" 
            #currentHoldTimeGrid
            class="ag-theme-balham flex-fill w-100 h-100" 
            [gridOptions]="gridOptions">
        </ag-grid-angular>
    </div>
</div>